import { useIsOsanoCmpActive } from 'context/common/OsanoCmpContext'
import { subscribeToOsanoConsentRevocation } from 'lib/osanoConsentRevocation'
import { useEffect } from 'react'

/**
 * Reloads the page when the visitor saves Osano preferences that revoke a
 * previously granted category. Already-running vendor scripts (CallRail,
 * Contentsquare, Heap, ad pixels) cannot be unloaded, so a fresh document is
 * the only reliable way to honor the change.
 *
 * Must render under OsanoCmpProviderSyncedToAuth so it re-subscribes when
 * Osano activation flips (e.g. support login/logout).
 */
const useReloadOnConsentRevocation = (): void => {
  const isOsanoCmpActive = useIsOsanoCmpActive()

  useEffect(
    () =>
      subscribeToOsanoConsentRevocation(() => {
        window.location.reload()
      }),
    [isOsanoCmpActive]
  )
}

export default useReloadOnConsentRevocation
